module.exports = __webpack_public_path__ + "media/images/faces/male/32-a5d135d5cb286d85b17b3a1146793ca8.jpg";